import {ActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/ActDecorator';
import {SignalEventEmitterWrapper} from '@gongxigames/framework/core/services/strictEventEmitter';
import {strictGameEmitter, GameOnlyEventMap} from '@gongxigames/framework/slotV2/globals';

/**
 * Extend ListenerActDecorator if you want just listen to some events and not block
 * the other Acts chain.
 * It will automatically remove all listeners in the end of the State.
 */
export abstract class ListenerActDecorator<T = GameOnlyEventMap> extends ActDecorator {
    readonly emitter: SignalEventEmitterWrapper<T> = new SignalEventEmitterWrapper(strictGameEmitter, {signal: this.abortSignal, owner: this}) as any;

    public executeSkipOnRoot?: () => void;

    /**
     * add listeners here
     * @param executeSkip call the method to skip the whole State
     */
    public listen(): void {

    }

    public executeSkip(): void {
        this.executeSkipOnRoot?.();
    }

    public abstract getName(): string;

    public removeAllListeners(): void {
        super.removeAllListeners();
        this.emitter.offAllByOwner();
    }
}